import { CircularProgress } from '@material-ui/core';
import StopIcon from '@material-ui/icons/Stop';
import { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';

const TeamChart = ({
  dashboardInfo,
  isLoadingDashboard,
  isFetchingDashboard,
}) => {
  const [options, setOptions] = useState({
    chart: {
      type: 'bar',
      toolbar: {
        show: true,
        tools: {
          download: false,
        },
      },
      responsive: [
        {
          breakpoint: 1000,
          options: {
            plotOptions: {
              bar: {
                columnWidth: '50%',
              },
            },
          },
        },
      ],
      margin: {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
      },
    },
    plotOptions: {
      bar: {
        distributed: true,
        borderRadius: 10,
        borderRadiusApplication: 'end',
        horizontal: false,
        columnWidth: '55%',
      },
    },
    dataLabels: {
      enabled: false,
    },
    legend: {
      show: false,
      position: 'top',
      horizontalAlign: 'left',
    },
    colors: ['#8EB7FF', '#8E92FF', '#FF8E8E', '#FFC78E'],
    xaxis: {
      categories: [
        'Équipe(s)',
        'Apprenant(s) intégré(s)',
        'Apprenant(s) en alternance',
        'Apprenant(s) en stage',
      ],
      labels: {
        show: false,
        style: {
          colors: [],
          fontSize: '14px',
        },
      },
    },
    yaxis: {
      labels: {
        formatter: function (val) {
          return parseInt(val, 10);
        },
      },
    },
  });

  const [series, setSeries] = useState([]);

  useEffect(() => {
    if (dashboardInfo?.viewsStats) {
      setSeries([
        {
          name: 'Nombre',
          data: [
            dashboardInfo?.teamStats?.totalTeam || 0,
            dashboardInfo?.teamStats?.integrateStudents || 0,
            dashboardInfo?.teamStats?.alternanceStudents || 0,
            dashboardInfo?.teamStats?.internshipStudents || 0,
          ],
        },
      ]);
    }
  }, [dashboardInfo]);

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <div style={{ display: 'flex', columnGap: 10, flexWrap: 'wrap' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <StopIcon style={{ color: '#8EB7FF' }} />
          <p style={{ margin: 0 }}>Équipes</p>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <StopIcon style={{ color: '#8E92FF' }} />
            <p style={{ margin: 0 }}>Apprenants intégrés</p>
          </div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <StopIcon style={{ color: '#FF8E8E' }} />
            <p style={{ margin: 0 }}>Apprenants en alternance</p>
          </div>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <StopIcon style={{ color: '#FFC78E' }} />
            <p style={{ margin: 0 }}>Apprenants en stage</p>
          </div>
        </div>
      </div>

      {isFetchingDashboard || isLoadingDashboard ? (
        <div
          style={{
            height: '100%',
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: 20,
            marginTop: 20,
          }}
        >
          <CircularProgress />
        </div>
      ) : (
        series?.length > 0 && (
          <Chart
            options={options}
            series={series}
            type="bar"
            height="300"
            width={'100%'}
          />
        )
      )}
    </div>
  );
};

export default TeamChart;
